import styled, { css } from "styled-components";

export const Wrapper = styled.div<{ $height?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: ${({ $height }) => ($height ? `${$height}px` : "100%")};
`;

export const Inner = styled.div<{
  $type: string;
  $color: string;
  $length: number;
  $thickness: number;
}>`
  opacity: 0.7;
  ${({ $type, $color, $length, $thickness }) => {
    switch ($type) {
      case "rule":
        return css`
          width: ${$length}%;
          border-top: ${$thickness}px solid ${$color};
        `;
      case "short":
        return css`
          width: ${$length}%;
          height: 1px;
          border-top: ${$thickness}px solid ${$color};
          position: absolute;
          left: 0;
        `;
      case "vertical":
        return css`
          width: 1px;
          height: ${$length}%;
          border-left: ${$thickness}px solid ${$color};
        `;
      case "dots":
        return css`
          width: ${$length}%;
          border-bottom: ${$thickness}px dotted ${$color};
        `; // or border-image + svg
      default:
        return css``; // gap
    }
  }}
`;
